import { traceSaveParams, getTempInfo } from '../common.js';
import Util from '../util';

export const setRiskModalData = (text)=>{
	return {
		type: 'RISK_MODAL_DATA',
		text
	}
}

export const setPayLoading = (text)=>{
	return {
		type: 'SET_PAY_LOADING',
		text
	}
}

export const traceSave = (params)=>{
	return async (dispatch, getState)=>{
		console.log(traceSaveParams);
		if (typeof params=='undefined'){
			return;
		}
		let action = params.action;
		params.token = await getTempInfo('shortToken');
		params.action = traceSaveParams.traceAction[action];
		params.appName = traceSaveParams.appName;
		params.appVersion = traceSaveParams.appVersion;
		params.deviceName = await traceSaveParams.deviceName;
		params.deviceType = traceSaveParams.deviceType;
		params.os = traceSaveParams.os;
		params.deviceId = traceSaveParams.deviceId;
		Util.post(Util.url + '/api/account/traceSave', params, (suc)=>console.log('留痕', params ,suc), (err)=>console.log('留痕失败', params ,err));
	}
}



// WEBPACK FOOTER //
// ./src/action/riskInPayAction.js